module.exports = __webpack_public_path__ + "img/371.84282a05.svg";